// Mock data for portfolio website

export const siteInfo = {
  name: "Kowshik Ram",
  avatar: "/kowshik.jpg",
  title: "Writer & Programmer",
  location: "Bengaluru, India",
  description: "Product builder based in Bengaluru, currently working at Pleo.",
  intro: {
    greeting: "Hello! I'm",
    bio: "I'm a developer based in Bengaluru, currently working at Pleo. And in the side, I'm building Useful Ventures, A startup studio turning real problems into useful AI products.",
    bioLink: null,
    previousWork: "Before Pleo I spent a few years at",
    previousWorkLink: { text: "Razorpay", url: "https://razorpay.com/" },
    previousWorkDesc: ", shipping payments infrastructure and tooling for Indian startups.",
    hobbies: "I also like watching",
    photosLink: { text: "movies", url: "/movies" },
    travelLink: { text: "traveling", url: "/travel" }
  },
  social: {
    twitter: "https://x.com/KowshikRam1",
    linkedin: "https://www.linkedin.com/in/kowshik-ram-64458317b/",
    instagram: "https://www.instagram.com/kowshik_ram/"
  }
};

export const navigation = {
  craft: [
    { name: "Writing", path: "/writing", icon: "Pencil", count: 0 },
    { name: "Projects", path: "/projects", icon: "FolderOpen" }
  ],
  lists: [
    { name: "Movies", path: "/movies", icon: "Clapperboard" },
    { name: "Software", path: "/software", icon: "Monitor" },
    { name: "Travel", path: "/travel", icon: "Plane" }
  ]
};

export const writingTags = [
  "All"
];

// Keep the structure but start empty so the section renders cleanly until
// you're ready to add your own posts.
export const writings = [];

export const photos = [
  ];

export const movieTags = [
  "All",
  "Malayalam",
  "Hindi",
  "English",
  "Tamil",
  "Telugu",
  "Korean",
];

export const movies = [
  { id: 1, title: "Kaantha", tags: ["Tamil"] },
  { id: 3, title: "The Terminal", tags: ["English"] },
  { id: 4, title: "Ford v Ferrari", tags: ["English"] },
  { id: 5, title: "Marriage Story", tags: ["English"] },
  { id: 7, title: "Sarpatta Parambarai", tags: ["Tamil"] },
  { id: 8, title: "O Kadhal Kanmani", tags: ["Tamil"] },
  { id: 9, title: "Tamasha", tags: ["Hindi"] },
  { id: 10, title: "Retro", tags: ["Tamil"] },
  { id: 11, title: "12th Fail", tags: ["Hindi"] },
  { id: 12, title: "1917", tags: ["English"] },
  { id: 13, title: "WALL-E", tags: ["English"] },
  { id: 14, title: "Baby Driver", tags: ["English"] },
  { id: 15, title: "Demonte Colony", tags: ["Tamil"] },
  { id: 16, title: "Fight Club", tags: ["English"] },
  { id: 18, title: "Maanagaram", tags: ["Tamil"] },
  { id: 19, title: "Asuran", tags: ["Tamil"] },
  { id: 20, title: "Kaala", tags: ["Tamil"] },
  { id: 21, title: "Meiyazhagan", tags: ["Tamil"] },
  { id: 23, title: "Aattam", tags: ["Malayalam"] },
  { id: 24, title: "Ullozhukku", tags: ["Malayalam"] },
  { id: 25, title: "The Social Network", tags: ["English"] },
  { id: 26, title: "Joker", tags: ["English"] },
  { id: 27, title: "The Fault in Our Stars", tags: ["English"] },
  { id: 28, title: "Bird Box", tags: ["English"] },
  { id: 29, title: "Flow", tags: ["English"] },
  { id: 30, title: "Home", tags: ["Malayalam"] },
  { id: 31, title: "Thudarum", tags: ["Malayalam"] },
  { id: 32, title: "The Queen's Gambit", tags: ["English"] },
  { id: 33, title: "The Intern", tags: ["English"] },
  { id: 34, title: "Logan", tags: ["English"] },
  { id: 35, title: "The Martian", tags: ["English"] },
  { id: 36, title: "The Departed", tags: ["English"] },
  { id: 37, title: "Top Gun: Maverick", tags: ["English"] },
  { id: 38, title: "Goodfellas", tags: ["English"] },
  { id: 39, title: "Jojo Rabbit", tags: ["English"] },
  { id: 40, title: "Vada Chennai", tags: ["Tamil"] },
  { id: 41, title: "Salaar", tags: ["Telugu"] },
  { id: 42, title: "Interstellar", tags: ["English"] },
  { id: 43, title: "Parasite", tags: ["Korean"] },
];

export const travels = [
  { id: 1, location: "Goa & Gokarna, India", year: 2022 },
  { id: 2, location: "Vancouver, Canada", year: 2023 },
  { id: 3, location: "Varkala, India", year: 2024 },
  { id: 4, location: "Masinagudi & Ooty, India", year: 2024 },
];

export const projects = [
  { id: 1, name: "Useful Ventures", description: "A small startup studio building useful products.", tech: [], url: "https://useful.ventures/", year: 2025 },
  { id: 2, name: "Email Client", description: "AI native email client for small business and freelancers", tech: ["AI", "Email"], url: "https://crewm8.ai/", year: 2025 },
  { id: 3, name: "Dating Assistant", description: "Designing dating app assistant which moves away from swipping", tech: ["Dating", "AI"], url: "#", year: 2025 }
];

export const software = [
  { id: 1, name: "Codex", description: "Coding Assistant", category: "Development" },
  { id: 2, name: "Notion", description: "Notes and knowledge management", category: "Productivity" },
  { id: 4, name: "Poke", description: "Personal Assistant", category: "Productivity" },
  { id: 5, name: "Linear", description: "Issue tracking for modern teams", category: "Development" },
  { id: 6, name: "Claude Code", description: "AI-powered code assistant", category: "Development" }
];

export const greatWriting = [];
